import { getAuthenticityToken } from 'Shared/helpers'
import FetcherFactory from 'Shared/FetcherFactory'

import { CLS_MODAL_QUERY_PARAM } from '../constants'

export const reducerName = 'CLONE_LEAGUES_SESSIONS_CREATOR'

const SUCCESS_STATUS_CODES = [ 202 ]

const factory = new FetcherFactory(
  reducerName,
  ({ params, state }) => {
    const { cloneLeaguesSessionID, data } = params

    // Replace the :session_id placeholder in the URL template with the actual session ID
    const url = state.baseURL.replace(':session_id', cloneLeaguesSessionID)

    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'X-CSRF-Token': getAuthenticityToken(),
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        clone_leagues_session_id: cloneLeaguesSessionID,
        data: data,
      }),
    }).then(response => {
      return response.json().then(data => {
        if (SUCCESS_STATUS_CODES.includes(response.status)) {
          const queryString = new URLSearchParams({ [CLS_MODAL_QUERY_PARAM]: data?.id }).toString()
          window.location.href = `${state.redirectURL}?${queryString}`
        }

        return ({
          data: data,
          status: response.status,
        })
      })
    })
  },
  {
    ignoreParamsCaching: true,
  },
)

export const getInitialState = ({ startCloneLeaguesSessionURL, indexCloneLeaguesSessionsURL }) => {
  return {
    data: {},
    baseURL: startCloneLeaguesSessionURL,
    redirectURL: indexCloneLeaguesSessionsURL,
  }
}

const cloneLeaguesSessionsStarterReducer = factory.getReducer()
export const startCloneLeaguesSession = factory.getFetchAction()

export const selectStarterLoading = state => state[reducerName]?.loading

export const namedReducer = { [factory.name]: cloneLeaguesSessionsStarterReducer }
